<mat-card sm-restrict-width id="client_container" class="help_page">
  <h2>{{ 'HELP.FAQ_TITLE' | translate }}</h2>
  {{ 'HELP.NEED_ASSISTANCE' | translate }} <a href="mailto:help@salonmonster">{{ 'HELP.CONTACT_US' | translate }}</a>
  <br /><br />
  <ul>
      <li><a href="" (click)="scroll(how_do_i_cancel_an_appointment)">{{ 'HELP.Q_CANCEL_APPOINTMENT' | translate }}</a></li>
      <li><a href="" (click)="scroll(is_my_data_stored_securely)">{{ 'HELP.Q_DATA_SECURITY' | translate }}</a></li>
      <li><a href="" (click)="scroll(can_i_change_an_appointment)">{{ 'HELP.Q_CHANGE_APPOINTMENT' | translate }}</a></li>
      <li><a href="" (click)="scroll(will_i_be_charged_for_this)">{{ 'HELP.Q_CHARGED' | translate }}</a></li>     
      <li><a href="" (click)="scroll(why_do_you_need_my)">{{ 'HELP.Q_EMAIL_PHONE' | translate }}</a></li>    
      <li><a href="" (click)="scroll(i_forgot_my_password)">{{ 'HELP.Q_FORGOT_PASSWORD' | translate }}</a></li>
  </ul>
</mat-card>

<br />
<div #how_do_i_cancel_an_appointment class="faq_box">
  <mat-card>
      <h3>{{ 'HELP.Q_CANCEL_APPOINTMENT' | translate }}</h3>
      <b>{{ 'HELP.A_CANCEL_TITLE' | translate }}</b><br />
      <ul>
        <li>{{ 'HELP.A_CANCEL_STEP1' | translate }}</li>
        <li>{{ 'HELP.A_CANCEL_STEP2' | translate }}</li>
        <li>{{ 'HELP.A_CANCEL_STEP3' | translate }}</li>
        <li>{{ 'HELP.A_CANCEL_STEP4' | translate }}</li>
        <li>{{ 'HELP.A_CANCEL_STEP5' | translate }}</li>
      </ul>
  </mat-card>
</div> 
  <br/>
<div #is_my_data_stored_securely>
  <mat-card class="faq_box">
      <h3>{{ 'HELP.Q_DATA_SECURITY' | translate }}</h3>
     {{ 'HELP.A_DATA_SECURITY' | translate }}<br />
  </mat-card>
</div>
  <br/>
<div #can_i_change_an_appointment>
  <mat-card #can_i_change_an_appointment class="faq_box">
      <h3>{{ 'HELP.Q_CHANGE_APPOINTMENT' | translate }}</h3>
      {{ 'HELP.A_CHANGE_INTRO' | translate }}
      <ul>
        <li>{{ 'HELP.A_CHANGE_STEP1' | translate }}</li>
        <li>{{ 'HELP.A_CHANGE_STEP2' | translate }}</li>
        <li>{{ 'HELP.A_CHANGE_STEP3' | translate }}</li>
        <li>{{ 'HELP.A_CHANGE_STEP4' | translate }}</li>
        <li>{{ 'HELP.A_CHANGE_STEP5' | translate }}</li>
      </ul>
  </mat-card>
</div>
  <br/>
<div #will_i_be_charged_for_this >
  <mat-card class="faq_box">
      <h3>{{ 'HELP.Q_CHARGED' | translate }}</h3>
      {{ 'HELP.A_CHARGED' | translate }}<br />
  </mat-card>
</div>
  <br/>
<div  #why_do_you_need_my>
  <mat-card class="faq_box">
      <h3>{{ 'HELP.Q_EMAIL_PHONE' | translate }}</h3>
      <b>{{ 'HELP.A_EMAIL_REASON' | translate }}</b><br /><br />
      <b>{{ 'HELP.A_PHONE_REASON' | translate }}</b><br /><br />
      {{ 'HELP.A_NO_SHARE' | translate }} <a (click)="scroll(is_my_data_stored_securely)">{{ 'HELP.A_NO_SHARE_LINK' | translate }}</a>
  </mat-card>
</div>
  <br/>
  <div #i_forgot_my_password>
    <mat-card class="faq_box">
        <h3>{{ 'HELP.Q_FORGOT_PASSWORD' | translate }}</h3>
        <em>{{ 'HELP.A_FORGOT_NEW_USERS' | translate }}</em><br /><br />
        <em>{{ 'HELP.A_FORGOT_EMAIL_TITLE' | translate }}</em><br />
        {{ 'HELP.A_FORGOT_STEP1' | translate }}<br />
        {{ 'HELP.A_FORGOT_STEP2' | translate }} "<a href="" (click)="forgotPassword()">{{ 'HELP.A_FORGOT_LINK' | translate }}</a>" {{ 'HELP.A_FORGOT_STEP2_CONT' | translate }}<br />
        {{ 'HELP.A_FORGOT_STEP3' | translate }}
    </mat-card>
  </div>
  <br/>

